module.exports = __webpack_public_path__ + "static/media/girloncomputer1.2ee71b47.jpg";